import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";

export default function Emails() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  useEffect(() => { api.get("/emails").then((r) => setItems(r.data)); }, []);
  const open = async (id) => {
    const r = await api.get(`/emails/${id}`);
    setSelected(r.data);
  };
  return (
    <div className="p-8 space-y-6" data-testid="emails-root">
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">Notifications</div>
        <h1 className="font-heading text-4xl mt-1 tracking-tight">Portal Log</h1>
        <p className="text-sm text-zinc-500 mt-1">
          All transactional emails sent by the system. Configure <code className="bg-zinc-100 px-1 py-0.5 text-xs">RESEND_API_KEY</code> in
          backend/.env to enable real email delivery — otherwise emails are logged here in demo mode.
        </p>
      </div>

      <div className="bg-white border border-zinc-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-zinc-50 text-[10px] uppercase tracking-widest text-zinc-500">
            <tr>
              <th className="text-left p-4">Sent At</th>
              <th className="text-left p-4">Kind</th>
              <th className="text-left p-4">Recipient</th>
              <th className="text-left p-4">Subject</th>
              <th className="text-left p-4">Provider</th>
              <th className="text-left p-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-zinc-400">No emails yet.</td></tr>}
            {items.map((e) => (
              <tr key={e.id} className="border-t border-zinc-100 hover:bg-zinc-50 cursor-pointer"
                  onClick={() => open(e.id)} data-testid={`email-row-${e.id}`}>
                <td className="p-3 text-xs tabular-nums text-zinc-500">{new Date(e.at).toLocaleString()}</td>
                <td className="p-3 font-mono text-xs">{e.kind}</td>
                <td className="p-3">{e.to}</td>
                <td className="p-3 truncate max-w-xs">{e.subject}</td>
                <td className="p-3 text-zinc-600 text-xs">{e.sent_via}</td>
                <td className="p-3">
                  <span className={`px-2 py-0.5 text-[10px] uppercase tracking-widest border ${
                    e.status === "sent" ? "bg-emerald-50 text-emerald-800 border-emerald-300" :
                    e.status === "failed" ? "bg-rose-50 text-rose-800 border-rose-300" :
                    "bg-zinc-50 text-zinc-600 border-zinc-300"}`}>{e.status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog open={!!selected} onOpenChange={(v) => !v && setSelected(null)}>
        <DialogContent className="bg-white rounded-sm max-w-3xl max-h-[85vh] overflow-y-auto">
          <DialogHeader><DialogTitle className="font-heading">{selected?.subject}</DialogTitle></DialogHeader>
          <div className="text-xs text-zinc-500 space-y-1 mb-4">
            <div>To: <span className="text-zinc-900 font-mono">{selected?.to}</span></div>
            <div>Kind: {selected?.kind} · Status: {selected?.status} · Via: {selected?.sent_via}</div>
          </div>
          {selected?.html && (
            <div className="border border-zinc-200 rounded-sm overflow-hidden">
              <iframe title="Email preview" srcDoc={selected.html}
                      className="w-full h-[500px] bg-white" sandbox="" />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
